// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"dR","hoverImage":"eR","hovered":"fR","mainImage":"gR","imageNoBackground":"hR","fullSizeImage":"iR"};